import React from 'react'
import styles from "./TryonText.module.scss";

const TryonText = () => {
  return (
    <>
    <span  className={styles.swanCtaMainText}>
    <span  className={styles.swanCtaMainText__text}>Swan</span>
    <span  className={styles.swanCtaMainText__bgText}>Try-On</span>
  </span>
  </>
  )
}

export default TryonText